import {
  IS_NEW_ARRIVAL,
  IS_NEAR_DEDLINE,
  EMPLOYMENT_STATUS_MAPPING,
  HOLIDAY_AND_WAY_OF_WORKING_MAPPING,
  REQUIREMENTS_MAPPING,
  WORKPLACE_ENVIRONMENT_MAPPING,
  WELFARE_BENEFITS_MAPPING,
  LANGUAGE_SKILLS_MAPPING,
  POSITIONS_MAPPING,
  EMPLOYEE_AVERAGE_AGE_MAPPING,
} from '@doda/common/src/constants/hydrogenOldParamMap';
import {
  JOB_SEARCH_LINK_TEXT,
  JOB_RANKING_LINK_TEXT,
  OCCUPATION_LINK_TEXT,
} from '@doda/common/src/constants/seo/jobContentCommonConstants';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import {
  measureClickJobSearchListLink,
  measureClickJobRankingLink,
  measureClickOccupationLink,
} from '@doda/common/src/logics/JobContent/JobTrend/analytics';

/**
 * 年収用上限下限
 * @param id
 * @param lowerId 下限id
 * @param upperId 上限id
 * @param name 項目名
 */
export interface IncomeKodawariType {
  id: string;
  lowerId: string;
  upperId: string;
  name: string;
}
// 年収別の求人数から取得した文言からURL作成用のパラメータを確認するため、定数として文言とidを置く
export const UPPER_AND_LOWER_HA = [
  {
    id: '1',
    lowerId: '30',
    upperId: '40',
    name: '年収300万円～400万円',
  },
  {
    id: '2',
    lowerId: '40',
    upperId: '50',
    name: '年収400万円～500万円',
  },
  {
    id: '3',
    lowerId: '50',
    upperId: '60',
    name: '年収500万円～600万円',
  },
  {
    id: '4',
    lowerId: '60',
    upperId: '70',
    name: '年収600万円～700万円',
  },
  {
    id: '5',
    lowerId: '70',
    upperId: '80',
    name: '年収700万円～800万円',
  },
  {
    id: '6',
    lowerId: '80',
    upperId: '90',
    name: '年収800万円～900万円',
  },
  {
    id: '7',
    lowerId: '90',
    upperId: '100',
    name: '年収900万円～1000万円',
  },
  {
    id: '8',
    lowerId: '100',
    upperId: '0',
    name: '年収1000万円～',
  },
] as const;

export const LABEL_NAME = {
  REQUIREMENT: '募集・採用情報',
  INCOME: '年収',
  WORKPLACE_ENVIRONMENT: '会社・職場の環境',
  HOLIDAY_AND_WAY_OF_WORKING: '休日・働き方',
  EMPLOYEE_AVERAGE_AGE: '社員の平均年齢',
  EMPLOYMMENT_STATUS: '雇用形態',
  WELFARE_BENEFITS: '待遇・福利厚生',
  LANGUAGE_AND_POSITIONS: '仕事内容・語学',
  ESTABLISH: '設立年数',
};

export const LABEL_FLAG = {
  REQUIREMENT: 'requirements',
  INCOME: 'income',
  WORKPLACE_ENVIRONMENT: 'workplaceEnvironment',
  HOLIDAY_AND_WAY_OF_WORKING: 'holidayAndWayOfWorking',
  EMPLOYEE_AVERAGE_AGE: 'employeeAverageAge',
  EMPLOYMMENT_STATUS: 'employmentStatus',
  WELFARE_BENEFITS: 'welfareBenefits',
  LANGUAGE_AND_POSITIONS: 'languageAndPositions',
  ESTABLISH: 'establish',
};

export const OP_VALUE_MAPPINGS = {
  isNewArrival: IS_NEW_ARRIVAL,
  isNearDeadline: IS_NEAR_DEDLINE,
  employmentStatusList: EMPLOYMENT_STATUS_MAPPING,
  holidayAndWayOfWorkingList: HOLIDAY_AND_WAY_OF_WORKING_MAPPING,
  requirementsList: REQUIREMENTS_MAPPING,
  workplaceEnvironmentList: WORKPLACE_ENVIRONMENT_MAPPING,
  welfareBenefitsList: WELFARE_BENEFITS_MAPPING,
  languageSkillsList: LANGUAGE_SKILLS_MAPPING,
  positionsList: POSITIONS_MAPPING,
  employeeAverageAgeList: EMPLOYEE_AVERAGE_AGE_MAPPING,
};

// 年収カウント数
export const LOWER_INCOME_LIST = ['3', '5', '7', '9', '11', '12', '13', '14'];
export const UPEER_INCOME_LIST = ['5', '7', '9', '11', '12', '13', '14'];

// 求人トレンドページ_キャリーID
export const JOB_TREND_CARRY_ID = '5100004793';

// 求人トレンドページ_ログアウト計測用
export const JOB_TREND = 'JobTrend';

// 注釈文言
export const ANNOTATION_TEXT_1 =
  'このページのデータは最新のdoda掲載の全求人を対象としています。';
export const ANNOTATION_TEXT_2 =
  '年収については、求人で募集している年収の幅が広い場合、複数の年収帯にまたがる場合があります。';

// 計測用文言
export const PAGE_NAME_PC = '求人のトレンド';
export const PAGE_NAME_SP = 'SP_求人のトレンド';
export const CHANNEL = '求人コンテンツ';
export const ANALYTICS_OP_NAME = 'op__';
export const ANALYTICS_HA_NAME = 'ha__';
export const ANALYTICS_ES_NAME = 'es__';

// Snackbar使用画像
export const CLOSE_IMG_LINK = '/cmn_web/img/cm/icon/close_white.svg';
export const CURSOR_IMG_LINK = '/cmn_web/img/index/cursor_white.svg';
export const FINGER_IMG_LINK = '/cmn_web/img/index/sp/tap_white.svg';

// FAQフレーズ
export const FAQ_TITLE = 'doda掲載中求人について まとめ';
export const COMMON_QUESTION_PHRASE = 'doda掲載中の求人では、';
export const COMMON_ANSWER_PHRASE = '現在doda掲載中の求人では、';
export const REQUIREMENTS_QUESTION =
  'どのような募集・採用条件の求人が多いですか？';
export const REQUIREMENTS_ANSWER = 'の募集・採用条件の求人が多い傾向です。';
export const INCOME_QUESTION = 'どれくらいの年収帯の求人が多いですか？';
export const INCOME_ANSWER = 'の年収帯の求人が多い傾向です。';
export const WORKPLACEENVIRONMENT_QUESTION =
  'どのような会社・職場の環境の求人が多いですか？';
export const WORKPLACEENVIRONMENT_ANSWER =
  'の会社・職場の環境の求人が多い傾向です。';
export const HOLIDAYANDWAYOFWORKING_QUESTION =
  'どのような休日・働き方の求人が多いですか？';
export const HOLIDAYANDWAYOFWORKING_ANSWER =
  'の休日・働き方の求人が多い傾向です。';
export const EMPLOYMENTSTATUS_QUESTION =
  'どのような雇用形態の求人が多いですか？';
export const EMPLOYMENTSTATUS_ANSWER = 'の求人が多い傾向です。';

// カテゴリ別の求人トレンドタイトル名
export const OTHER_JOB_TREND_TITLE = '他の求人の傾向を見る';

export const OTHER_PAGE_LINK_ITEMS = [
  {
    title: JOB_SEARCH_LINK_TEXT.TITLE,
    description: JOB_SEARCH_LINK_TEXT.DESCRIPTION,
    siteUrl: DODA_SITE_URL.jobSearchList,
    imagePath: JOB_SEARCH_LINK_TEXT.IMAGE_PATH,
    preBtn: true,
    handleMeasurement: measureClickJobSearchListLink,
  },
  {
    title: JOB_RANKING_LINK_TEXT.TITLE,
    description: JOB_RANKING_LINK_TEXT.DESCRIPTION,
    siteUrl: DODA_SITE_URL.jobRanking,
    imagePath: JOB_RANKING_LINK_TEXT.IMAGE_PATH,
    preBtn: false,
    handleMeasurement: measureClickJobRankingLink,
  },
  {
    title: OCCUPATION_LINK_TEXT.TITLE,
    description: OCCUPATION_LINK_TEXT.DESCRIPTION,
    siteUrl: DODA_SITE_URL.occupation,
    imagePath: OCCUPATION_LINK_TEXT.IMAGE_PATH,
    preBtn: false,
    handleMeasurement: measureClickOccupationLink,
  },
];
